module.exports = __webpack_public_path__ + "static/img/google.d669c99e.png";